export default "__VITE_ASSET__aa4df9f6__"